import {
  game,
  THREE
} from '@powerplay/core-minigames'
import { player } from '../athlete/player'

/**
 * Lines Manager
 * Trieda spravujuca drahy po ktorych behaju hraci
 */
export class LinesManager {

  /** dostupne drahy */
  private playerPaths: THREE.CurvePath<THREE.Vector3>[] = []

  /**
   * init
   */
  public init(): void {

    const gameObjectWithLines = new THREE.Group()

    const pathName = 'Javelin_TrackLine'
    const trackPlayer = game.getObject3D(pathName)
    trackPlayer.visible = false
    this.playerPaths[0] = new THREE.CurvePath<THREE.Vector3>()
    this.setupCurvePathFromObject(trackPlayer as THREE.LineSegments, this.playerPaths[0])

    gameObjectWithLines.add(trackPlayer)

    game.scene.add(gameObjectWithLines)


  }

  /**
   * @returns - drahu, ak je validny index
   */
  public getPath(): THREE.CurvePath<THREE.Vector3> | undefined {

    console.log(this.playerPaths)
    return this.playerPaths[0]

  }

  /**
   * Vytvorenie curvePath z modelu
   * @param object - objekt s krivkou
   * @param curvePath - objekt, kde ulozime curvePath
   */
  private setupCurvePathFromObject(
    object: THREE.LineSegments,
    curvePath: THREE.CurvePath<THREE.Vector3>
  ): void {

    const pointsArray: number[] = Array.from(object.geometry.attributes.position.array)
    const coordinates: (THREE.Vector3 | undefined)[] = pointsArray
      .map((_: number, idx: number, origArray) => {

        if (idx % 3 !== 0) {

          return undefined

        }
        return new THREE.Vector3(
          origArray[idx],
          origArray[idx + 1],
          origArray[idx + 2],

        )

      }).filter(e => e !== undefined)

    if (coordinates.includes(undefined)) {

      // error
      return

    }

    const lastPoint = new THREE.Vector3()
    coordinates.forEach((point, index) => {

      if (point === undefined) return
      if (index === 0) console.log(point)
      if (index > 0) {

        curvePath.add(new THREE.LineCurve3(
          new THREE.Vector3(lastPoint.x, lastPoint.y, lastPoint.z),
          new THREE.Vector3(point.x, point.y, point.z)
        ))

      }

      lastPoint.copy(point)

    })

  }

  /**
   * Vytovrenie debug bodov podla typu triggeru
   */
  public debugPointsTrigger(percent: number): THREE.Mesh {

    const geometrySphere = new THREE.SphereGeometry(0.2, 0.2, 0.2)
    const materialSphere = new THREE.MeshBasicMaterial({ color: 0x00FF00 })

    const meshSphere = new THREE.Mesh(geometrySphere, materialSphere)
    const position = player.worldEnvLinesManager.playerPath?.getPointAt(percent) ?? new THREE.Vector3(0, 0, 0)
    meshSphere.position.set(position.x, position.y + 0.2, position.z)
    meshSphere.name = 'debug'
    game.scene.add(meshSphere)
    return meshSphere

  }

  /**
   * Vypocitanie configu podla percenta na jednej trati
   * @param percent - percento drahy
   * @param index - index drahy
   */
  public getConfigFromOnePoint(percent: number, index: number): number[] {

    const oneMetersInPercent = [] as number[]
    for (let i = 1; i < this.playerPaths.length; i++) {

      oneMetersInPercent[i - 1] = 1 / this.playerPaths[i]?.getLength() || 0

    }

    const meters = 1 / oneMetersInPercent[index] * percent
    const config = [] as number[]

    for (let i = 0; i < this.playerPaths.length - 1; i++) {

      config[i] = oneMetersInPercent[i] * meters

    }

    console.log(config)
    return config

  }

  /**
   * Odstranenie debug bodov podla typu triggeru
   * @param type - Typ triggera
   */
  public removeDebugPointsTrigger(type = 'finish'): void {

    this.playerPaths.forEach((_value, index) => {

      const mesh = game.getMesh(`${index}_${type}_debug`)
      mesh.name += '_removed'
      mesh.visible = false

    })

  }

  /**
   * Getter
   * @returns playerPaths
   */
  public getPaths(): THREE.CurvePath<THREE.Vector3>[] {

    return this.playerPaths

  }

}
export const linesManager = new LinesManager()